/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Unpublished_WarningInputs */

const cs_portals_unpublished_warning = /** @type {(inputs: Portals_Unpublished_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost není publikovaná na webu. Portály lze zapnout nezávisle (web ≠ portál).`)
};

const en_portals_unpublished_warning = /** @type {(inputs: Portals_Unpublished_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing is unpublished on the website. Portals can still be enabled (website ≠ portal).`)
};

/**
* | output |
* | --- |
* | "Listing is unpublished on the website. Portals can still be enabled (website ≠ portal)." |
*
* @param {Portals_Unpublished_WarningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_unpublished_warning = /** @type {((inputs?: Portals_Unpublished_WarningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Unpublished_WarningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_unpublished_warning(inputs)
	return cs_portals_unpublished_warning(inputs)
});